import * as AUTH_ACTION from 'js/constant/action/auth'
import { createAction } from 'redux-actions'

const updateIsAuthenticated = createAction(AUTH_ACTION.UPDATE_IS_AUTHENTICATED)
const updateUser = createAction(AUTH_ACTION.UPDATE_USER_DETAILS)
const updateMobileSidebar = createAction(AUTH_ACTION.OPEN_MOBILE_SIDEBAR)

export const authorizeUser =
    () =>
      async (dispatch, getState, { auth }) => {
        try {
          const response = await auth.authorizeUser()
          dispatch(updateUser(response.user))
          dispatch(updateIsAuthenticated(true))
          return response
        } catch (error) {
          dispatch(updateIsAuthenticated(false))

          console.error(error)
        }
      }

export const getUserDetails =
    (user) =>
      async (dispatch, getState, { auth }) => {
        try {
          dispatch(updateUser({ username: user.name, profile_image: user.picture }))
          dispatch(updateIsAuthenticated(true))
        } catch (error) {
          dispatch(updateIsAuthenticated(false))
          console.error(error)
        }
      }

export const setOpenMobileSidebar =
    (bool) =>
      (dispatch, getState, { auth }) => {
        dispatch(updateMobileSidebar(bool))
      }
